export default __webpack_public_path__ + "static/media/D_Dente.8b217594.mp3";